import React, {useEffect} from 'react';
import styled from "styled-components";
import {useSelector} from "react-redux";
import refundReducer, {fetchPosts} from "../api/redux/refundpolicy";
import {Col, Container, Row} from "react-bootstrap";
import Title from "../../components/Title";
import {hover} from '../../styles/globalStyleVars'
import {TimelineLite} from "gsap";
import reactHtmlParser from "react-html-parser";
import {useRouter} from "next/router";
import {NextSeo} from "next-seo";
import {wrapper} from "../api/store";
import {ApiServices} from "../api/network/ApiServices";
import {ApiParamKey} from "../api/network/ApiParamKey";
import {ScrollTrigger} from "gsap/dist/ScrollTrigger";

const Terms = ({offset}) => {


    let getPost = useSelector(state => state.refundReducer)
    let page_data = getPost?.posts?.data?.page_data
    let load_list = getPost?.posts?.download_list
    const download_cta = getPost?.posts?.data?.sections?.find(f => f?.section_data?.slug === 'downloads-cta');
    const banner = getPost?.posts?.data?.sections?.find(f => f?.section_data?.slug === 'banner-about');

    console.log(getPost, 'klsdjf')

    // for 404 page
    useEffect(() => {
        setTimeout(() => {
            const tl = new TimelineLite()
            tl.to('.page-transition', {
                delay: 1,
                opacity: 0,
                duration: 1,
                display: 'none'
            }).to('.page-transition .logo', {
                duration: .6,
                opacity: 0
            }, '-=.6')
        }, 1500)
        ScrollTrigger.refresh();

        // Scroll to top when page changes
        window.scrollTo(0, 0);


    }, [getPost])

    const router = useRouter();
    const currentUrl = router && router.asPath;


    return (
        <>
            <NextSeo
                title={`${page_data?.title ? page_data?.title + ' | Shanta Securities Limited' : 'Shanta Securities Limited'}`}
                description={page_data?.meta_description}
                canonical={"https://www.shantasecurities.com" + currentUrl}
                openGraph={{
                    type: 'website',
                    url: "https://www.shantasecurities.com" + currentUrl,
                    title: page_data?.og_title,
                    description: page_data?.og_description,
                    images: [
                        {
                            url: banner?.images?.list?.[0]?.full_path,
                            width: 800,
                            height: 600,
                            alt: page_data?.og_title,
                        },
                        {
                            url: banner?.images?.list?.[0]?.full_path,
                            width: 800,
                            height: 600,
                            alt: page_data?.og_title,
                        },
                    ],
                }}
            />

            <StyledComponent>
                <Container>
                    <Row>
                        <Col md={12} className="black pt-200 pb-200">
                            <Title noanim text={'Refund Policy'}
                                   fontSize={'44'} fontWeight={'400'} margin={'0 0 40px'} lineHeight={'56'}/>

                            <div className="content min-height">

                                {
                                    page_data?.description ?
                                    reactHtmlParser(page_data?.description) :

                                   ''
                                }

                            </div>
                        </Col>
                    </Row>
                </Container>
            </StyledComponent>
        </>
    );
};



const StyledComponent = styled.section`
    min-height: 90vh;


    ul, ol {
        li {
            padding-left: 20px;
            position: relative;
            margin-bottom: 20px;

            &:last-child {
                margin-bottom: 0;
            }

            &:after {
                height: 10px;
                width: 10px;
                background: ${hover};
                content: '';
                position: absolute;
                left: 0;
                top: 5px;
                border-radius: 50%;
            }
        }
    }
`;
Terms.getInitialProps = wrapper.getInitialPageProps((store) => async () => {
    let api_services = ApiServices.SECTIONS;
    let param = {
        [ApiParamKey.TYPE]: 'slug',
        [ApiParamKey.VALUE]: 'refund-policy',
        [ApiParamKey.GET_SECTION]: 'yes',
        [ApiParamKey.IMAGE]: 'yes',
        [ApiParamKey.POST]: 'yes',
        [ApiParamKey.GALLERY]: 'yes',
    }
    await store.dispatch(fetchPosts([api_services, param]));
});

export default Terms;
